export default "__VITE_ASSET__WqKg5q$P__"